import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            const saved = localStorage.getItem("dib-cart");
            return saved ? JSON.parse(saved) : [];
        } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem("dib-cart", JSON.stringify(items));
    }, [items]);

    const addItem = (product) => {
        const price = parsePrice(product.price_text);
        if (price <= 0) return false;
        
        const shippingCost = product.shipping_cost ?? (product.shipping_type === "accessories" ? 15 : 350);
        const shippingLabel = product.shipping_label || (product.shipping_type === "accessories" ? "Standard Ground Shipping" : "Insured Nationwide Flat-Rate Freight Shipping");
        
        setItems(prev => {
            const existing = prev.find(i => i.product_id === product.id);
            if (existing) return prev;
            return [...prev, {
                product_id: product.id,
                product_name: product.display_title,
                price,
                quantity: 1,
                image_url: product.images?.[0] || "",
                shipping_cost: shippingCost,
                shipping_label: shippingLabel,
                manufacturer: product.manufacturer || "",
                monthly_payment_text: product.monthly_payment_text || ""
            }];
        });
        return true;
    };

    const removeItem = (productId) => {
        setItems(prev => prev.filter(i => i.product_id !== productId));
    };

    const clearCart = () => setItems([]);

    const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
    const shippingCost = items.reduce((sum, i) => sum + (i.shipping_cost || 0) * i.quantity, 0);
    const itemCount = items.length;

    return (
        <CartContext.Provider value={{ items, addItem, removeItem, clearCart, subtotal, shippingCost, itemCount }}>
            {children}
        </CartContext.Provider>
    );
};

function parsePrice(priceText) {
    if (!priceText) return 0;
    const match = priceText.replace(/,/g, "").match(/\$?([\d]+(?:\.\d{2})?)/);
    return match ? parseFloat(match[1]) : 0;
}
